// ======================================================================
// 📁 drawer-planning.mapper.js
// PURPOSE:
//   Convert backend planning context → UI operation model
// ======================================================================

/**
 * Map backend routing operations into drawer UI model.
 */
export const mapBackendOperations = (
  backendOperations = [],
  materials = [],
  availableTools = []
) => {
  return backendOperations.map((op) => {
    // 🔧 tool lookup map
    const toolMap = {};
    availableTools.forEach((t) => {
      toolMap[t.tool_id] = t;
    });

    return {
      // --------------------------------------------------
      // Identity
      // --------------------------------------------------
      seq: op.seq,

      routingAssignmentOperationId:
        op.routing_assignment_operation_id ?? null,

      // --------------------------------------------------
      // Operation info
      // --------------------------------------------------
      name: op.operation_name,
      type: op.operation_type || "INHOUSE",

      predecessor: op.predecessor || null,

      // --------------------------------------------------
      // Machine assignment
      // --------------------------------------------------
      machineGroups: op.machine_groups || [],
      machinesByGroup: op.machines_by_group || {},

      machines: op.machines || [],
      selectedMachineId:
        op.machines?.[0] ??
        op.selected_machine_id ??
        null,

      // --------------------------------------------------
      // Worker assignment
      // --------------------------------------------------
      skill: op.skill || null,
      workersBySkill: op.workers_by_skill || {},

      workers: op.workers || [],
      selectedWorkerId:
        op.workers?.[0] ??
        op.selected_worker_id ??
        null,

      // --------------------------------------------------
      // Planning time
      // --------------------------------------------------
      plannedMinutes:
        op.planned_minutes ??
        op.planned_duration_minutes ??
        0,

      from: op.planned_start_datetime || "",
      to: op.planned_end_datetime || "",

      // --------------------------------------------------
      // ✅ TOOLS — REHYDRATED FROM MASTER
      // --------------------------------------------------
      tools: (op.tools || []).map((toolId) => {
        const tool = toolMap[toolId];
        return tool
          ? {
              tool_id: tool.tool_id,
              tool_name: tool.tool_name,
            }
          : { tool_id: toolId };
      }),

      // --------------------------------------------------
      // Working areas
      // --------------------------------------------------
      workingAreas: op.working_areas || [],

      // --------------------------------------------------
      // Materials snapshot
      // --------------------------------------------------
      materials,

      readiness: op.readiness || "READY",
    };
  });
};
